import styled from 'styled-components'

export const Container = styled.div`
  width: 300px;

  @media only screen and (min-width: 768px) {
    /* For everything bigger than 768px */
    width: 450px;
  }

  @media only screen and (max-width: 360px) {
    /* For everything less than 300px */
    width: 250px;
  }
`

export const Heading = styled.span`
  font-size: 24px;
  color: rgba(50, 50, 93, 0.7);
`



// WEBPACK FOOTER //
// ./src/routes/SignUp/styles.js